import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export default function CateringsSection() {
  const { t } = useTranslation('homepage');

  return (
    <Wrapper>
      <Box>
        <Title>{t('cateringsSection.categories')}</Title>
        <Container>
          <FlexColumn>
            <Link href="/de/fingerfood" passHref legacyBehavior>
              <StyledLink>{t('cateringsSection.fingerFood')}</StyledLink>
            </Link>
            <Link href="/de/fruehstueck" passHref legacyBehavior>
              <StyledLink>{t('cateringsSection.breakfast')}</StyledLink>
            </Link>
            <Link href="/de/food-truck" passHref legacyBehavior>
              <StyledLink>{t('cateringsSection.foodTruck')}</StyledLink>
            </Link>
            <Link href="/de/events" passHref legacyBehavior>
              <StyledLink>{t('cateringsSection.events')}</StyledLink>
            </Link>
          </FlexColumn>
          <FlexColumn>
            <Link href="/de/buffet" passHref legacyBehavior>
              <StyledLink>{t('cateringsSection.buffet')}</StyledLink>
            </Link>
            <Link href="/de/vegan" passHref legacyBehavior>
              <StyledLink>{t('cateringsSection.vegan')}</StyledLink>
            </Link>
            <Link href="/de/grill-catering" passHref legacyBehavior>
              <StyledLink>{t('cateringsSection.grill')}</StyledLink>
            </Link>
            <Link href="/de/sommerfest" passHref legacyBehavior>
              <StyledLink>{t('cateringsSection.summerParty')}</StyledLink>
            </Link>
          </FlexColumn>
        </Container>
      </Box>
      <Box>
        <Title>{t('cateringsSection.city')}</Title>
        <Container>
          <FlexColumn>
            <Link href="/de/catering-berlin" passHref legacyBehavior>
              <StyledLink>{t('cateringsSection.berlin')}</StyledLink>
            </Link>
            <Link href="/de/catering-muenchen" passHref legacyBehavior>
              <StyledLink>{t('cateringsSection.munich')}</StyledLink>
            </Link>
            <Link href="/de/catering-hamburg" passHref legacyBehavior>
              <StyledLink>{t('cateringsSection.hamburg')}</StyledLink>
            </Link>
            <Link href="/de/catering-frankfurt-am-main" passHref legacyBehavior>
              <StyledLink>{t('cateringsSection.frankfurt')}</StyledLink>
            </Link>
          </FlexColumn>
          <FlexColumn>
            <Link href="/de/catering-duesseldorf" passHref legacyBehavior>
              <StyledLink>{t('cateringsSection.duesseldorf')}</StyledLink>
            </Link>
            <Link href="/de/catering-koeln" passHref legacyBehavior>
              <StyledLink>{t('cateringsSection.cologne')}</StyledLink>
            </Link>
            <Link href="/de/catering-leipzig" passHref legacyBehavior>
              <StyledLink>{t('cateringsSection.leipzig')}</StyledLink>
            </Link>
            <Link href="/de/catering-hannover" passHref legacyBehavior>
              <StyledLink>{t('cateringsSection.hannover')}</StyledLink>
            </Link>
          </FlexColumn>
        </Container>
      </Box>
      <CountriesBox>
        <Title>{t('cateringsSection.country')}</Title>
        <FlexColumn>
          <Link href="/de/catering-oesterreich" passHref legacyBehavior>
            <StyledLink>{t('cateringsSection.austria')}</StyledLink>
          </Link>
          <Link href="/de/catering-deutschland" passHref legacyBehavior>
            <StyledLink>{t('cateringsSection.germany')}</StyledLink>
          </Link>
          <Link href="/de/catering-schweiz" passHref legacyBehavior>
            <StyledLink>{t('cateringsSection.switzerland')}</StyledLink>
          </Link>
        </FlexColumn>
      </CountriesBox>
    </Wrapper>
  );
}

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)}px;
`;

const Title = styled(Typography)`
  font-size: 16px;
  font-weight: 600;
  line-height: 27.6px;
  margin-bottom: ${({ theme }) => theme.spacing(1)}px;
`;

const StyledLink = styled.a`
  font-size: 14px;
  line-height: 23.52px;
  color: #3c4340;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${({ theme }) => theme.spacing(0.5, 2)};
  ${({ theme }) => theme.breakpoints.up('sm')} {
    display: flex;
    gap: ${({ theme }) => theme.spacing(4)}px;
  }
`;

const CountriesBox = styled(Box)`
  grid-column: span 2;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    grid-column: auto;
  }
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${({ theme }) => theme.spacing(3, 2)};
  margin: auto;
  padding: ${({ theme }) => theme.spacing(0, 2)};
  ${({ theme }) => theme.breakpoints.up('sm')} {
    display: flex;
    justify-content: space-between;
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 1002px;
    padding: 0;
  }
`;
